export default __webpack_public_path__ + "static/media/homeowner_portal_hero.1cabbc4b.webp";